import { useMobile } from '../../../../common/services/screenSize/ScreenSizeService';
import {
  StyledLink,
  LinkSectionView,
  LinkTitle,
} from '../SidebarLinkSection/SidebarLinkSection.styles';
import { ImportantInformationContainer } from './ImportantInformation.styles';

export const ImportantDentalInformation = () => {
  const importantInfoLinks = [
    {
      title: 'When should you see a dentist about a toothache?',
      url: 'https://healthengine.com.au/info/When-should-you-see-a-dentist-about-a-toothache',
    },
    {
      title: 'How long should you wait to get a cavity filled?',
      url: 'https://healthengine.com.au/info/How-long-should-you-wait-to-get-a-cavity-filled',
    },
    {
      title: 'Maxillofacial Surgery',
      url: 'https://healthengine.com.au/info/Maxillofacial-Surgery',
    },
    {
      title: 'Dental Associations',
      url: 'https://healthengine.com.au/info/Dental-Associations',
    },
    {
      title: 'Affordable Dental Care Guide Sydney',
      url:
        'https://healthengine.com.au/info/your-ultimate-no-nonsense-guide-to-affordable-dental-care-in-sydney',
    },
    {
      title: 'Affordable Dental Care Guide Melbourne',
      url:
        'https://healthengine.com.au/info/ultimate-no-nonsense-guide-affordable-dental-care-melbourne',
    },
    {
      title: 'Affordable Dental Care Guide Brisbane',
      url:
        'https://healthengine.com.au/info/ultimate-no-nonsense-guide-affordable-dental-care-brisbane',
    },
  ];

  const isMobile = useMobile();

  return (
    <LinkSectionView>
      {isMobile && <LinkTitle>Important Information</LinkTitle>}
      <ImportantInformationContainer>
        {importantInfoLinks.map(link => (
          <StyledLink key={`${link.title}-${String(link.url)}`} to={link.url}>
            {link.title}
          </StyledLink>
        ))}
      </ImportantInformationContainer>
    </LinkSectionView>
  );
};

export const ImportantGPInformation = () => {
  const importantInfoLinks = [
    {
      title: 'Influenza Vaccine (Flu Vaccine)',
      url: 'https://healthinfo.healthengine.com.au/influenza-vaccine-flu-vaccine-2',
    },
    {
      title: 'What Does a GP Do?',
      url: 'https://healthinfo.healthengine.com.au/general-practice',
    },
    {
      title: 'Cold and flu: What to Eat',
      url:
        'https://healthinfo.healthengine.com.au/cold-and-flu-what-to-eat-to-help-relieve-specific-symptoms-2',
    },
    {
      title: 'How Your Doctor Can Help',
      url:
        'https://healthinfo.healthengine.com.au/your-gp-can-help-you-in-more-ways-than-you-realise',
    },
    {
      title: 'When to see the GP for my cold?',
      url: 'https://healthinfo.healthengine.com.au/when-to-see-a-doctor-about-your-cold',
    },
    {
      title: 'Children’s Health',
      url: 'https://healthinfo.healthengine.com.au/paediatrics',
    },
  ];

  const isMobile = useMobile();

  return (
    <LinkSectionView>
      {isMobile && <LinkTitle>Important Information</LinkTitle>}
      <ImportantInformationContainer>
        {importantInfoLinks.map(link => (
          <StyledLink key={`${link.title}-${String(link.url)}`} to={link.url}>
            {link.title}
          </StyledLink>
        ))}
      </ImportantInformationContainer>
    </LinkSectionView>
  );
};
